import { render, staticRenderFns } from "./userCourseFrom.vue?vue&type=template&id=36a4f4e8&scoped=true"
import script from "./userCourseFrom.vue?vue&type=script&lang=js"
export * from "./userCourseFrom.vue?vue&type=script&lang=js"
import style0 from "./userCourseFrom.vue?vue&type=style&index=0&id=36a4f4e8&prod&lang=scss"
import style1 from "./userCourseFrom.vue?vue&type=style&index=1&id=36a4f4e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a4f4e8",
  null
  
)

export default component.exports